import type { RuleSetId } from '../../../../model';

// VIEW_LOG

export const VIEW_LOG = 'state.actions.rule.view-log.VIEW_LOG' as const;

export type ViewLogAction = {
	type: typeof VIEW_LOG;
	payload: {
		ruleSetId: RuleSetId;
	};
};

export const viewLogAction = (ruleSetId: RuleSetId): ViewLogAction => ({
	type: VIEW_LOG,
	payload: {
		ruleSetId,
	},
});
